module.exports = __webpack_public_path__ + "static/media/logo.e72a2ca1.svg";